import { PayloadAction } from '@reduxjs/toolkit';
import { BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const setCloseTargetIdAction = (state: BottomSheetState, action: PayloadAction<string | null>) => {
	state.closeTargetId = action.payload;
};
